import React, { useRef } from "react";
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton, LinkedinShareButton } from "react-share";
import showMessage from "../../components/tripOverview/Common/notification";
import { ADD_SHARE_NAME } from "../../graphQL/mutations";
import classes from './modal.module.scss'
import { useMutation } from "@apollo/client";
import copy from 'copy-to-clipboard';
import TextField from "@mui/material/TextField";
import { itinerary } from "../Types";
import { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { useParams } from "react-router-dom";
interface props {
    modal: string | true
    setModal: React.Dispatch<React.SetStateAction<string | boolean>>
    rename: string
    setRename: React.Dispatch<React.SetStateAction<string>>
    setNewURL: React.Dispatch<React.SetStateAction<string>>
    newURL: string
    type: string | null
    save: string
    name: string
    buliddata: itinerary | undefined
    getItineraryRefetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>
    setShareTypeClick: React.Dispatch<React.SetStateAction<string | boolean>>
    setCopyLink: React.Dispatch<React.SetStateAction<string | boolean>>

}

const RenameGeneralModal: React.FC<props> = ({ modal, setModal, rename, setRename, setNewURL, newURL, type, save, name, buliddata, getItineraryRefetch, setShareTypeClick, setCopyLink }) => {
    const { id } = useParams()
    const [updateData] = useMutation(ADD_SHARE_NAME, {
        variables: {
            name: rename,
            itinerary: { id: buliddata?.id }
        }
    })
    const facebookRef = useRef<HTMLButtonElement>(null);
    const whatsappRef = useRef<HTMLButtonElement>(null);
    const emailRef = useRef<HTMLButtonElement>(null);
    const twitterRef = useRef<HTMLButtonElement>(null);
    const LinkedinRef = useRef<HTMLButtonElement>(null);

    const handelCopyLink = (newurl: string) => {
        copy(newurl, {
            debug: true,
            message: 'Copy',
        });
        copy(newurl)
        setCopyLink('shareWithFamily')
        setShareTypeClick('')
        setTimeout(() => {
            setCopyLink(false)
        }, 1000)
        setModal(false)
    }
    const handelCopyLink1 = (newurl: string) => {
        copy(newurl, {
            debug: true,
            message: 'Copy',
        });
        copy(newurl)
        setCopyLink('publicShare')
        setShareTypeClick(true)
        setTimeout(() => {
            setCopyLink(false)
        }, 1000)
        setModal(false)
    }

    const Reftrigger = async (newurl: string) => {


        if (newurl) {
            await setNewURL(newurl)
            switch (modal) {
                case 'Facebook':
                    return facebookRef.current!.click()
                case 'Linkedin':
                    return LinkedinRef.current!.click()
                case 'Whatsapp':
                    return whatsappRef.current!.click()
                case 'Email':
                    return emailRef.current!.click()
                case 'Twitter':
                    return twitterRef.current!.click()
                case 'copy':
                    if (type === 'family')
                        return handelCopyLink(newurl)
                    else
                        return handelCopyLink1(newurl)
                default:
                    return null
            }

        }
        setTimeout(() => {
            setModal(false)
        }, 1000);
    }
    const Save = async () => {
        const urlBase = window.location.hostname.includes("travelsment.com") ? `https://${window.location.hostname}` : 'https://192.168.1.20:3000';
        let newurl = '';

        const encodeData = (data: string) => {
            let encodedData = btoa(data);
            while (encodedData.endsWith('=')) {
                encodedData = encodedData.slice(0, -1);
            }
            return encodedData;
        };

        try {
            if (rename && buliddata && buliddata.parentRef) {
                const existingShare = buliddata.shares.find((n) => n.name.replace(/\s+/g, '') === rename.replace(/\s+/g, ''));

                if (rename === buliddata.name) {
                    const dataToEncode = `share=${type}&id=${buliddata?.parentRef?.key ? buliddata?.parentRef?.key : id}`;
                    newurl = `${urlBase}/viewer/v1/share/${encodeData(dataToEncode)}`;
                    Reftrigger(newurl);
                    setRename(buliddata.name);

                } else if (existingShare) {
                    const dataToEncode = `share=${type}&id=${buliddata?.parentRef?.key ? buliddata?.parentRef?.key : id}&copy=${existingShare.id}`;
                    newurl = `${urlBase}/viewer/v1/share/${encodeData(dataToEncode)}`;
                    Reftrigger(newurl);
                    setRename(buliddata.name);
                    setModal(false);

                } else {
                    const response = await updateData({
                        variables: {
                            name: rename,
                            itinerary: { id: buliddata.id }
                        }
                    });
                    const newShareId = response.data.addShareItinerary.shareItinerary[0].id;
                    const dataToEncode = `share=${type}&id=${buliddata?.parentRef?.key ? buliddata?.parentRef?.key : id}&copy=${newShareId}`;
                    newurl = `${urlBase}/viewer/v1/share/${encodeData(dataToEncode)}`;
                    Reftrigger(newurl);
                    getItineraryRefetch();
                    setRename(buliddata.name);
                    setModal(false);
                }
            } else {
                showMessage("Error", "Please Enter a Name", 'danger');
            }
        } catch (error) {
            showMessage("Error", "Failed to update data", 'danger');
        }
        setShareTypeClick(true);
    };

    const handleEmailOnClick = () => {
        window.location.href = encodeURI(`mailto:
        ?subject=My trip
        &body=Hey,\n\n Please review my last trip ${newURL} \n\n Best Wishes`);
    };

    return <div>
        <div className={classes.modals} >
            <div className={classes.modalContent}>
                <div className={classes.area}>
                    <div className={classes.header}>
                        {name}
                    </div>
                    <div className={classes.body}>
                        <TextField className={classes.inputBox} fullWidth label="Itinerary Name" id="Itinerary Name" value={rename} onChange={(e) => setRename(e.target.value)} />
                    </div>
                    <div className={classes.buttonLayer}>
                        <button className={classes.Close} onClick={() => setModal(false)}>Cancel</button>
                        <button className={classes.Save} onClick={() => Save()}> {save} </button>
                        <div className={classes.hidden}>
                            <FacebookShareButton ref={facebookRef} url={newURL} quote={rename}> Save </FacebookShareButton>
                            <LinkedinShareButton ref={LinkedinRef} summary={rename} url={newURL} source='https://www.travelsment.com/'> Save </LinkedinShareButton>
                            <WhatsappShareButton ref={whatsappRef} url={newURL}> Save </WhatsappShareButton>
                            <EmailShareButton ref={emailRef} url={''} onClick={handleEmailOnClick}> Save </EmailShareButton>
                            {buliddata && <TwitterShareButton ref={twitterRef} title={buliddata.name} url={newURL} >Save</TwitterShareButton>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}

export default RenameGeneralModal